var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOxalisSiteWebBoutonsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.7 28.3",
    style: {
      enableBackground: "new 0 0 56.7 28.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.8,
    y: 6.2,
    className: "st0",
    width: 45,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.8,
    y: 20.1,
    className: "st0",
    width: 45,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxalisSiteWebBoutonsMenu);
export default __webpack_public_path__ + "static/media/OXALIS_site_web_boutons_menu.0646e0c34d8ad6c3cb38ca9d037811ba.svg";
export { ForwardRef as ReactComponent };